export enum Types {
  CHANGE_COMPONENT_HIGHLIGHT_ID = "CHANGE_COMPONENT_HIGHLIGHT_ID",
  CHANGE_CONFIGURATION_TYPE = "CHANGE_CONFIGURATION_TYPE",
}
